import {
    defineStore
} from 'pinia'
import {
    setStore,
    getStore
} from './utils/store'
import {
    ElMessage
} from "element-plus";
export const HomeStore = defineStore('Home', {
    state: () => {
        return {
            isReply: false, //是否显示回复消息框
            menuComponent: "dialogue", //活跃的组件
            menuIndex: "",
            isDialog: false, //全屏弹窗
            isDialog1: false, //全屏弹窗
            isDialog2: false, //全屏弹窗
            isDialog3: false, //全屏弹窗
            isDialog4: false, //全屏弹窗
            setting: {
                isCreateChannel: false,
                isAddUser: false,
                isEditdescribe: false,
                ischannelDetails: false,
                channelDetailName: "about",
                isUserDetails: false,
                addInfo: {
                    title: "添加好友",
                    type: 1,
                    channel: ""
                },
                dialogueInfo: {
                    type: '',
                },
                loading: false,
                loading1: false
            }, //设置
            chatMessageList: {}, //聊天信息
            chatScrollTop: {}, //保存聊天的位置
            chatQuery: {}, //查询条件
            Messagetip: {}, //新消息提醒
            isNeedQuery: {}, //是否需要查询消息
            isError: {}, //保存错误的提示信息
            channelList: [], //频道列表
            Temporarymessage: {}, //临时消息
            allusers: [], //用户下拉列表
            friends: [], //好友列表
            baseURL: "https://im.files99.com/",
            userInfo: '',
            token: getStore({
                name: 'token',
            }),
            socket: "",
            client_id: "",
            IspromptMessage: false,
            SelectedMessage: "", //选中的消息
            searchInfo: {
                type: 1,
            }, //搜索的关键字
            selectData: "", //发送对象的值
            selectUser: "",//选中的用户
            Isreduce: false,
            AsteriskList: [],
            IsSendMessage: false,
            isDetail: false,
            showDetail: false,
            ObjPopupData: {},
            ObjPopupData1: "",
            sendPopupData: {},
            isTopping: true,
            switchPopupData: {
                show: false,
                data: []
            },//是否切换对象详情
            savePopupData: {},//保存的对象详情
            selectInfoDataVisible: false,
            selectInfoDataType: "",
            SendPopupDataVisible: false,
            Chatobject: "", //切换聊天对象
            ReplyInfo: {
                replyMessageList: []
            },
            channelNum: 0,
            user_host: "",
            friend_host: "",//好友的服务器
            slackType: "",//
            visibilityState: true, //监听浏览器是否在当前窗口
            conversationObjectList: [],//保存会话对象
            detailLoading: false,
            lang: "en-us",
            IsPrivatechat: "", //是否有新会话
            IsDelPrivatechat: "", //是否删除了会话
            rfqGroupList:[],
        }
    },
    actions: {
        getunReadMsgCount() {

        },
        /* 聊天记录的修改,这里我们使用vuex监听 */
        SOCKET_updateChatMessageList(data) {
            this.chatMessageList[this.setting.dialogueInfo.id].push(data);
        },
        // //私聊
        // friendClick(val, index) {
        //     HomeStore().setMenuComponent("dialogue");
        //     HomeStore().setConfig("dialogueInfo", {
        //         type: 1,
        //         HeadPhotoUrl: val.user_avatar_file_name,
        //         id: val.user_uid,
        //         nickname: val.receiver_name,
        //     });
        //     HomeStore().getChatMessageList(val);
        //     if (val.unread > 0) {
        //         HomeStore().friends[index].unread = 0;
        //         $axios.msgread({
        //             token: HomeStore().token,
        //             friend_id: this.userInfo.user_uid,
        //         });
        //     }
        // },
        // //群聊
        // channelClick(item, index) {
        //     HomeStore().setMenuComponent("dialogue");
        //     HomeStore().setConfig("dialogueInfo", {
        //         group_name: item.group_name,
        //         description: item.description,
        //         type: 2,
        //         group_id: item.group_id,
        //     });
        //     HomeStore().getgroupchat(item);
        //     if (item.unread > 0) {
        //         $axios.groupread({
        //             token: HomeStore().token,
        //             group_id: item.group_id,
        //             readtype: "read",
        //         });
        //         HomeStore().channelList[index].unread = 0;
        //     }
        // },
        //提示信息
        TipMessage() {
            if (this.setting.dialogueInfo.type == 1) {
                if (this.isError[this.setting.dialogueInfo.id]) {
                    if (store.lang == "en-us") {
                        ElMessage({
                            type: "error",
                            message: "The other party has removed you.",
                        });
                    } else {
                        ElMessage({
                            type: "error",
                            message: "对方将你删除了.",
                        });
                    }
                    return true
                } else {
                    return false
                }
            } else {
                if (this.isError[this.setting.dialogueInfo.group_id]) {
                    if (store.lang == "en-us") {
                        ElMessage({
                            type: "error",
                            message: "The channel has been disbanded.",
                        });
                    }
                    else {
                        ElMessage({
                            type: "error",
                            message: "频道已解散.",
                        });
                    }
                    return true
                } else {
                    return false
                }
            }
        },
        //是否显示回复框
        setisReply(val) {
            this.isReply = val
        },
        //显示组件
        setMenuComponent(val) {
            this.menuComponent = val
            this.isReply = false
        },
        //获取用户信息
        setuserInfo(data) {
            this.userInfo = data
            setStore({
                name: 'userInfo',
                content: data,
            })
        },
        //获取用户token
        setToken(data) {
            this.token = data
            setStore({
                name: 'token',
                content: data,
            })
        },
        //修改设置
        setConfig(key, val) {
            this.setting[key] = val
        }
    },
})